import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Undefined' },
    { value: 1, label: 'World' },
    { value: 2, label: 'AU NZ' },
  ],
});
